import * as React from 'react';
import { send_authorized_request } from '../../Constants/cognito'
import { AXIOS_API_INSTANCE } from '../../Constants';
import { useSnackbar } from 'notistack';
import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip, debounce } from '@mui/material';
import Grid from "@mui/material/Grid2"
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PercentIcon from '@mui/icons-material/Percent'
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import axios from 'axios';
import { LoadingBackdropIndeterminate } from '../LoadingBackdrop';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import CheckBoxIcon from "@mui/icons-material/CheckBox"

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const deposit_type_options = [
    { name: "Percentage", value: "PERCENTAGE" },
    { name: "Flat Rate", value: "FLAT_RATE" },
    { name: "Flat Rate Per Bulk Item", value: "FLAT_RATE_PER_ITEM" },
]

export default function RentalTypePage({ rentalType, creatingNewRentalType, closeFunction }) {
    const { enqueueSnackbar } = useSnackbar();
    const [myRentalType, setMyRentalType] = React.useState(rentalType)
    const [isLoading, setIsLoading] = React.useState(false)
    const [categorySearch, setCategorySearch] = React.useState("")
    const [categoriesIsLoading, setCategoriesIsLoading] = React.useState(false)
    const [filteredCategories, setFilteredCategories] = React.useState({ rows: [], total_count: 0 })
    const [rateGroupSearch, setRateGroupSearch] = React.useState("")
    const [rateGroupsIsLoading, setRateGroupsIsLoading] = React.useState(false)
    const [filteredRateGroups, setFilteredRateGroups] = React.useState({ rows: [], total_count: 0 })
    const [fees, setFees] = React.useState({ rows: [], total_count: 0 })
    const [isFeesLoading, setIsFeesLoading] = React.useState(false)
    const [showFeeDetails, setShowFeeDetails] = React.useState(false)

    const updateRentalCategorySearch = (event, newInputValue) => {
        setCategorySearch(newInputValue)
        if (newInputValue.trim() !== categorySearch) {
            debouncedGetRentalCategories(newInputValue.trim())
        }
    }
    const updateRateGroupSearch = (event, newInputValue) => {
        setRateGroupSearch(newInputValue)
        if (newInputValue.trim() !== rateGroupSearch) {
            debouncedGetRateGroups(newInputValue.trim())
        }
    }

    const handleChange = (prop) => (event) => {
        console.log(myRentalType)
        if (["has_odometer", "bulk_type"].includes(prop)) {
            setMyRentalType({ ...myRentalType, [prop]: event.target.checked })
        } else {
            setMyRentalType({ ...myRentalType, [prop]: event.target.value })
        }

    }
    const handleFeeChange = (e, options, action, option) => {
        if (action === "removeOption") {
            myRentalType.fees = myRentalType.fees.filter((item) => item.id !== option.option.id)
            myRentalType.fee_ids = myRentalType.fee_ids.filter((item) => item !== option.option.id)
        } else {
            myRentalType.fees.push(option.option)
            myRentalType.fee_ids.push(option.option.id)
        }
        setMyRentalType({ ...myRentalType })
    }
    const update_question = (index, value) => {
        myRentalType.checkout_checkin_questions[index] = value
        setMyRentalType({ ...myRentalType })
    }
    const remove_question = (index) => {
        myRentalType.checkout_checkin_questions.splice(index, 1)
        setMyRentalType({ ...myRentalType })
    }
    const add_question = () => {
        myRentalType.checkout_checkin_questions.push('')
        setMyRentalType({ ...myRentalType })
    }

    // const uploadNewImage = (event) => {
    //     if (!event.target.files) {
    //         return;
    //     }
    //     const file = event.target.files[0];
    //     send_authorized_request(() =>
    //         AXIOS_API_INSTANCE.post(`rentaltype/${myRentalType.id}/image`, { image_name: file.name },).then((response) => {
    //             console.log(response)
    //             var bodyFormData = new FormData();
    //             for (const key in response.data.data.fields) {
    //                 bodyFormData.append(key, response.data.data.fields[key])
    //             }
    //             bodyFormData.append('file', file)
    //             axios.post(response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
    //                 console.log(response)
    //                 enqueueSnackbar('Successfully uploaded image', { variant: 'success' })
    //                 setMyRentalType({
    //                     ...myRentalType,
    //                     image_path: file.name,
    //                 })
    //             })
    //         })
    //     )
    // }

    const uploadNewDocumentation = (event) => {
        if (!event.target.files) {
            return;
        }
        const file = event.target.files[0];
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`rentaltype/${myRentalType.id}/documentation`, { documentation_name: file.name },).then((response) => {
                console.log(response)
                var bodyFormData = new FormData();
                for (const key in response.data.data.fields) {
                    bodyFormData.append(key, response.data.data.fields[key])
                }
                bodyFormData.append('file', file)
                axios.post(response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                    console.log(response)
                    enqueueSnackbar('Successfully uploaded documentation', { variant: 'success' })
                    setMyRentalType({
                        ...myRentalType,
                        documentation_path: file.name,
                    })
                })
            })
        )
    }

    const save = () => {
        setIsLoading(true)
        console.log(myRentalType)
        console.log("new rentaltype " + creatingNewRentalType)
        delete myRentalType.date_created
        delete myRentalType.date_updated
        if (creatingNewRentalType) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(`rentaltype`, myRentalType).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully created rental type', { variant: 'success' })
                        setIsLoading(false)
                        closeFunction(true)
                    })
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to create rental type <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `rentaltype/${myRentalType.id}`,
                    myRentalType
                ).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully updated rental type', { variant: 'success' })
                        setIsLoading(false)
                    })
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to update rental type <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        }
    }
    const delete_rental_type = () => {
        console.log('delete rentaltype')
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`rentaltype/${myRentalType.id}`).then(
                axios.spread(() => {
                    enqueueSnackbar('Successfully deleted rental type', { variant: 'success' })
                    closeFunction(true)
                })
            )
        )
    }

    const getRentalCategories = (categorySearch) => {
        setCategoriesIsLoading(true)
        let my_filters = { "or": [] }
        my_filters["or"].push({ 'name.ilike': categorySearch || "" })
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalcategories", {
                        params: {
                            page_num: 0,
                            page_size: 25,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((locations) => {
                        console.log(locations)
                        setFilteredCategories({
                            rows: locations.data.data,
                            total_count: locations.data.total_count,
                        })
                        setCategoriesIsLoading(false)
                    })
                )
        )
    }
    const debouncedGetRentalCategories = React.useMemo(() => debounce((categorySearch) => getRentalCategories(categorySearch), 400), []);

    const getRategroups = (rateGroupSearch) => {
        setRateGroupsIsLoading(true)
        let my_filters = { "or": [] }
        my_filters["or"].push({ 'name.ilike': rateGroupSearch || "" })
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalrategroups", {
                        params: {
                            page_num: 0,
                            page_size: 25,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((locations) => {
                        console.log(locations)
                        setFilteredRateGroups({
                            rows: locations.data.data,
                            total_count: locations.data.total_count,
                        })
                        setRateGroupsIsLoading(false)
                    })
                )
        )
    }
    const debouncedGetRateGroups = React.useMemo(() => debounce((rateGroupSearch) => getRategroups(rateGroupSearch), 400), []);

    const getFees = () => {
        setIsFeesLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("fees", {
                        params: {
                        },
                    }),
                ])
                .then(
                    axios.spread((fees) => {
                        console.log(fees)
                        setFees({
                            rows: fees.data.data,
                            total_count: fees.data.total_count,
                        })
                        setIsFeesLoading(false)
                    })
                )
        )
    }


    React.useEffect(() => {
        getRentalCategories(categorySearch)
        getRategroups(rateGroupSearch)
        getFees()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={isLoading}
                text={"Saving Rental Type"}
            />
            <Box sx={{ pl: 1, pr: 1 }}>
                <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                    <Grid size="grow">
                        <h2>{creatingNewRentalType ? "CREATING NEW RENTAL TYPE" : "EDITING RENTAL TYPE"}</h2>
                    </Grid>
                    <Grid size="auto">
                        <IconButton onClick={() => closeFunction(true)}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container spacing={10} justifyContent={"flex-end"}>
                    <Grid size="grow">
                        <Grid spacing={2} container direction="column">
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    value={myRentalType.name || ""}
                                    onChange={handleChange("name")}
                                />
                            </Grid>
                            <Grid size="grow">
                                <Autocomplete
                                    filterOptions={(x) => x}
                                    getOptionLabel={(option) => option.name || ""}
                                    options={categoriesIsLoading ? [] : filteredCategories.rows}
                                    autoComplete
                                    includeInputInList
                                    filterSelectedOptions
                                    value={myRentalType.rental_category}
                                    noOptionsText="No Categories"
                                    loading={categoriesIsLoading}
                                    onChange={(event, newValue) => {
                                        setMyRentalType({ ...myRentalType, rental_category: newValue, rental_category_id: newValue.id })
                                    }}
                                    onInputChange={updateRentalCategorySearch}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a Category" fullWidth />
                                    )}
                                    renderOption={(props, option, { inputValue }) => {
                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                        const parts = parse(props.key, matches);
                                        props.key = props.id

                                        return (
                                            <li {...props}>
                                                <div>
                                                    {parts.map((part, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                fontWeight: part.highlight ? 700 : 400,
                                                            }}
                                                        >
                                                            {part.text}
                                                        </span>
                                                    ))}
                                                </div>
                                            </li>
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid size="grow">
                                <Autocomplete
                                    filterOptions={(x) => x}
                                    getOptionLabel={(option) => option.name || ""}
                                    options={rateGroupsIsLoading ? [] : filteredRateGroups.rows}
                                    autoComplete
                                    includeInputInList
                                    filterSelectedOptions
                                    value={myRentalType.rental_rate_group}
                                    noOptionsText="No Rate Groups"
                                    loading={rateGroupsIsLoading}
                                    onChange={(event, newValue) => {
                                        setMyRentalType({ ...myRentalType, rental_rate_group: newValue, rental_rate_group_id: newValue.id })
                                    }}
                                    onInputChange={updateRateGroupSearch}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a Rate Group" fullWidth />
                                    )}
                                    renderOption={(props, option, { inputValue }) => {
                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                        const parts = parse(props.key, matches);
                                        props.key = props.id

                                        return (
                                            <li {...props}>
                                                <div>
                                                    {parts.map((part, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                fontWeight: part.highlight ? 700 : 400,
                                                            }}
                                                        >
                                                            {part.text}
                                                        </span>
                                                    ))}
                                                </div>
                                            </li>
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid size="grow">
                                <FormControl sx={{ width: "50%" }}>
                                    <InputLabel id="deposit-select-label">Deposit Type</InputLabel>
                                    <Select
                                        labelId="deposit-select-label"
                                        id="deposit-select"
                                        value={myRentalType.deposit_type}
                                        label="Deposit Type" // No idea why this is necessary but it fixes spacing issues
                                        onChange={handleChange("deposit_type")}
                                    >
                                        {deposit_type_options.map((option) =>
                                            < MenuItem value={option.value}>{option.name}</MenuItem>
                                        )
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size="grow">
                                <Grid container spacing={2} alignItems={"center"}>
                                    <Grid size="grow">
                                        <TextField
                                            margin="dense"
                                            id="depositcalculation"
                                            label="Deposit Calculation"
                                            type="number"
                                            fullWidth
                                            variant="standard"
                                            value={myRentalType.deposit_calculation || 0}
                                            onChange={handleChange("deposit_calculation")}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {myRentalType.deposit_type === 'PERCENTAGE' ? <PercentIcon /> : <AttachMoneyIcon />}
                                                        </InputAdornment>
                                                    ),
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid size="grow">
                                        {myRentalType.deposit_type === 'PERCENTAGE' && <Tooltip
                                            title="Include fees and tax in the deposit calculation?"
                                            arrow
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={myRentalType.deposit_include_fees || false}
                                                        onChange={handleChange("deposit_include_fees")}
                                                    />
                                                }
                                                label="Include Fees/Tax"
                                            />
                                        </Tooltip>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size="grow">
                        <Grid spacing={1} container direction="column">
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="description"
                                    label="Description"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    multiline
                                    minRows={2}
                                    value={myRentalType.description || ""}
                                    onChange={handleChange("description")}
                                    slotProps={{
                                        htmlInput: { maxLength: 255 }
                                    }}
                                />
                            </Grid>
                            <Grid size="grow">
                                <Grid container>
                                    <Grid size="grow">
                                        {/* <Button
                                            component="label"
                                            variant="outlined"
                                            startIcon={<UploadFileIcon />}
                                            sx={{ marginRight: "1rem" }}
                                            disabled={creatingNewRentalType}
                                        >
                                            Upload Image
                                            <input type="file" accept="image/*" hidden onChange={uploadNewImage} />
                                        </Button> */}
                                    </Grid>
                                    <Grid size="grow">
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            startIcon={<UploadFileIcon />}
                                            sx={{ marginRight: "1rem" }}
                                            disabled={creatingNewRentalType}
                                        >
                                            Upload Documentation
                                            <input type="file" accept="" hidden onChange={uploadNewDocumentation} />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size="grow">
                                <Tooltip
                                    title="Track odometer values on this rental type?"
                                    arrow
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={myRentalType.has_odometer || false}
                                                onChange={handleChange("has_odometer")}
                                            />
                                        }
                                        label="Has Odometer"
                                    />
                                </Tooltip>
                                <Tooltip
                                    title="Rent items in bulk quantities on this type?"
                                    arrow
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={myRentalType.bulk_type || false}
                                                onChange={handleChange("bulk_type")}
                                                disabled={!creatingNewRentalType}
                                            />
                                        }
                                        label="Bulk Type"
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid size="grow">
                                <Box sx={{ backgroundColor: 'lightgrey', border: '1px solid grey', paddingLeft: '5px', marginBottom: '5px' }}>
                                    <span><b>Fees</b></span>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showFeeDetails}
                                                onChange={() => setShowFeeDetails(!showFeeDetails)}
                                                sx={{ p: 0 }}
                                            />
                                        }
                                        label="Show Calculations"
                                        sx={{ float: 'right' }}
                                    />
                                </Box>
                                {isFeesLoading &&
                                    <CircularProgress />
                                }
                                {!isFeesLoading &&
                                    <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        clearIcon={<div></div>}
                                        sx={{ width: "100%", p: 1 }}
                                        onChange={handleFeeChange}
                                        getOptionLabel={(option) => {
                                            if (option.fee_type === 'PERCENTAGE') {
                                                return `${option.name || ""}${showFeeDetails ? ` (${option.calculation}%)` : ""}`
                                            } else if (option.fee_type === 'FLAT_RATE') {
                                                return `${option.name || ""}${showFeeDetails ? ` ($${option.calculation})` : ""}`
                                            } else if (option.fee_type === 'FLAT_RATE_PER_ITEM') {
                                                return `${option.name || ""}${showFeeDetails ? ` ($${option.calculation}/item)` : ""}`
                                            }
                                        }
                                        }
                                        value={myRentalType.fees}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        options={fees.rows}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                    value={option.id}
                                                />
                                                {`${option.name || ""} (${option.fee_type === 'PERCENTAGE' ? `${option.calculation}%` : `$${option.calculation}`})`}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Fees"
                                                placeholder="Rental Type's Fees"
                                            />
                                        )}
                                    />
                                }
                            </Grid>
                            <Grid size="grow">
                                <Grid container direction="column">
                                    <Grid size="grow">
                                        <Box sx={{ backgroundColor: 'lightgrey', border: '1px solid grey', paddingLeft: '5px', marginBottom: '5px' }}>
                                            <span><b>Check Out / In questions</b></span>
                                        </Box>
                                    </Grid>
                                    {(myRentalType.checkout_checkin_questions || []).map((item, index) =>
                                        <Grid size="grow">
                                            <Grid container>
                                                <Grid size="grow">
                                                    <TextField
                                                        margin="dense"
                                                        size='small'
                                                        id={`${index}-question`}
                                                        type="text"
                                                        hiddenLabel
                                                        fullWidth
                                                        variant="filled"
                                                        // inputProps={{ maxLength: 255 }}
                                                        value={item || ""}
                                                        onChange={(event) => update_question(index, event.target.value)}
                                                    />
                                                </Grid>
                                                <Grid size="auto">
                                                    <IconButton aria-label="delete" onClick={() => remove_question(index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                    <Grid size="grow" >
                                        <Grid size="auto">
                                            <Button onClick={add_question} >
                                                <AddCircleSharpIcon />
                                                Add Question
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid size="auto">
                        {!creatingNewRentalType &&
                            <Tooltip title={myRentalType.deletable_reason}>
                                <span> {/* span required for tooltip events */}
                                    <Button disabled={!myRentalType.deletable} variant='outlined' color='error' onClick={delete_rental_type} sx={{ mr: 1 }}>
                                        <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                    </Button>
                                </span>
                            </Tooltip>
                        }
                    </Grid>
                    <Grid size="auto">
                        <Button variant="contained" onClick={save}>
                            {creatingNewRentalType ? "Create" : "Save"}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment >)
    );
}